import React from 'react';
import { Element, PlaceholderText } from './ExchangeRates.styles';
import useExchangeRate from '@/components/exchange/hooks/useExchangeRate';
import { useTranslations } from 'next-intl';

export type ExchangeRatesProps = {
  appearance?: 'horizontal' | 'vertical';
};

const ExchangeRates = ({ appearance = 'horizontal' }: ExchangeRatesProps) => {
  const { values, isLoading, error } = useExchangeRate();
  const t = useTranslations('Header');

  return (
    <Element appearance={appearance}>
      <div>
        {(appearance === 'horizontal' && <small>{t('Câmbio')}</small>) || <small>{t('Atualizado em')}</small>}
        <PlaceholderText isLoading={isLoading}>
          <strong>{values.updated_at}</strong>
        </PlaceholderText>
      </div>
      <span></span>
      <div>
        <small>{t('Dólar')} (USD) </small>
        <PlaceholderText isLoading={isLoading}>
          <strong>R$ {values.usd}</strong>
        </PlaceholderText>
      </div>
      <span></span>
      <div>
        <small>Euro (EUR)</small>
        <PlaceholderText isLoading={isLoading}>
          <strong>R$ {values.eur}</strong>
        </PlaceholderText>
      </div>
      {(values.cad && (
        <>
          <span></span>
          <div>
            <small>{t('Dólar')} (CAD)</small>
            <PlaceholderText isLoading={isLoading}>
              <strong>R$ {values.cad}</strong>
            </PlaceholderText>
          </div>
        </>
      )) ||
        null}
    </Element>
  );
};

// ExchangeRates.messages = ['ExchangeRates'];

export default ExchangeRates;
